// TODO - Documentar
import { useEffect, useState } from 'react'
import {StaticTable} from '../../templates/tables/StaticTable'

import * as con from "../../GlobalConstants"
import * as globalFun from "../../GlobalFunctions"

// Style
import "./../ComponentsGlobalStyle.css"
import StatusIconSmall from '../../templates/loading/StatusIconSmall'
import {  RefApplicationParameterHook } from '../hooks/ApplicationParametersHooks'
import { getLine, getUserName } from '../../store/actions/authentication'
import { TransactionColumnsHook } from '../hooks/TransactionsHooks'
import { buildDefaultRow } from '../../utils/transactionFunctions'
import { AllSurrogateObjectiveBands, AllSurrogateTransactionsExpiryDates, RefSurrogateTransactionsLoadedHook } from '../hooks/SurrogateTransactionsHooks'
import { BandSelect, ScenariosSelect } from '../parameters/SingleParameters'
import { Button } from '@blueprintjs/core'
import { getMainAdvisorName } from '../../store/actions/advisors'
// import Modal from '../../templates/popups/Modal'
// import AdminUserLineComments from './AdminUserLineComments'
import { useDispatch, useSelector } from 'react-redux'
import { selectAllSurrogateUserTransactionsOk } from '../../store/selectors/surrogateUserTransactionsSelector'
import { fetchAllSurrogateTransactions } from '../../store/slices/surrogateUserTransactionsSlice'

const DEFAULT_COLUMNS=  [{ [con.ID] : con.USERNAME},
                  { [con.ID] : con.ADVISOR},
                  { [con.ID] : con.LINE},
                  { [con.ID] : con.EXPOSURE_AMOUNT},
                  { [con.ID] : con.COVERAGE_AMOUNT},                      
                  { [con.ID] : con.RATE},
                  { [con.ID] : con.COVERAGE_PERCENTAGE} ,
                  { [con.ID] : con.POSITION_IN_BANDS},
                  { [con.ID] : con.OBJECTIVE_BAND},
                  { [con.ID] : con.OBJECTIVE_BAND_PERCENTAGE },
                  { [con.ID] : con.VAR},
                  { [con.ID] : con.EXPIRY_DAYS},
                  { [con.ID] : con.LAST_EDITED}]                  


export const AdminDashboardTableSummary = ({selectedColumns = DEFAULT_COLUMNS, computing, allSurrogateTransactionsSummaries}) => {

    const dispatch = useDispatch()
    // Transactions loaded
    const surrogateLoading = RefSurrogateTransactionsLoadedHook()
    const allTransactionsLoaded = useSelector(selectAllSurrogateUserTransactionsOk)

    const transactionsCol = TransactionColumnsHook(selectedColumns, false)

    // // Surrogate User Dict
    const surrogateUserDict = RefApplicationParameterHook(con.SURROGATE_USER_DICT)

    // Expiry Column
    const expiryDays = AllSurrogateTransactionsExpiryDates()

    // Objective Band
    const objectiveBands = AllSurrogateObjectiveBands()
    
    // Comments
    // const [viewComments, setViewComments] = useState(() => false)

    // //Selected Summary Line
    // const [selectedLineSummary, setSelectedLineSummary] = useState(() => null)

    // // Table Data
    const [tableData, setTableData] = useState(() => constructTableData(allSurrogateTransactionsSummaries, expiryDays, objectiveBands, transactionsCol))

    useEffect(() => {
      if(!computing)
        setTableData(constructTableData(allSurrogateTransactionsSummaries, expiryDays, objectiveBands, transactionsCol))      
    
    }, [computing,allSurrogateTransactionsSummaries, transactionsCol, expiryDays, objectiveBands ])
    
    // useEffect(() => {
    
    // }, [selectedLineSummary])

    return (
        <div style={{marginBottom : "2vh"}}>

                {/* <Modal show={viewComments} doAccept={null} doCancel={() => setViewComments(false)} widthPercentage={75}>
                    { selectedLineSummary !== null ? <AdminUserLineComments selectedLineSummary={selectedLineSummary} /> : <div></div>}
                </Modal> */}

              <div className="gridBox" style={{ display : 'flex', justifyContent : 'space-around'}}>
                <div style={{}}>
                  <div className="columnParameterBox">                  
                    <Button icon="refresh" text="Refrescar" onClick={() => dispatch(fetchAllSurrogateTransactions())}/>
                  </div>
                </div>
                <div style={{}}>  
                  <ScenariosSelect />   
                </div>     
                <div style={{}}>  
                  <BandSelect />
                </div>        
             </div>
            {
            
            
            // If still loading from DB  
            !allTransactionsLoaded ?
              <div>
                <h4>Extrayendo las transacciones de la base de datos.</h4>
                <div className="mediumParameterBox">
                  <StatusIconSmall status={surrogateLoading[con.MODEL_PARAMETERS]} title={"Parámetros"}/> 
                  <StatusIconSmall status={surrogateLoading[con.EXPOSURES]} title={"Exposiciones"}/>
                  <StatusIconSmall status={surrogateLoading[con.COVERAGES_FWD]} title={"Coberturas FWD"}/>
                  <StatusIconSmall status={surrogateLoading[con.COVERAGES_OPTION]} title={"Coberturas Opciones"}/>                                       
                  <StatusIconSmall status={surrogateLoading[con.COVERAGES_SPOT]} title={"Coberturas SPOT"}/> 
                  <StatusIconSmall status={surrogateLoading[con.ACCOUNTS]} title={"Cuentas"}/> 
                </div>
              </div>
             : computing ? <h4>Computando</h4> : 
             <div>
              <StaticTable columnArray={transactionsCol} 
                              dataDictionary={tableData}
                              compress={true}
                              smallFont={true}
                              filterFunction={(tr) => globalFun.allDashboardEnabledUsers(surrogateUserDict[tr[con.USER_ID]])}
                              // onclickFunction={(rowData) => {

                              //   setSelectedLineSummary(rowData)
                              //   setViewComments(true)

                              // }}
                              />
              </div>
            }

        </div>
    )
}




const constructTableData = (transSummary, expiryDays, objectiveBands, transactionsCol) =>
{
  let defaultRow = buildDefaultRow(transactionsCol)
  let tableData = []
  Object.keys(transSummary).forEach(userId =>
    {
      Object.keys(transSummary[userId]).forEach(lineId => {
          let line = getLine(userId, lineId)
          let ob = {...defaultRow,
                    [con.ID] : tableData.length,
                    [con.USERNAME] : getUserName(userId),
                    [con.ADVISOR] : getMainAdvisorName(userId),
                    [con.USER_ID] : parseInt(userId),
                    [con.LINE] : line[con.NAME],
                    [con.LINE_ID] : lineId,
                    [con.LAST_EDITED] : line[con.LAST_EDITED],
                    ...transSummary[userId][lineId][con.SUMMARY_ROW],
                    ...objectiveBands[userId][lineId],
                    [con.EXPIRY_DAYS] : expiryDays[userId][lineId]}                
          tableData.push(ob)
      })
    })

    // Convert to dictionary
    tableData = Object.assign({}, ...tableData.map((x,i) => ({[i]: x})));

    return(tableData)

}

